import { render, staticRenderFns } from "./GStatusChip.vue?vue&type=template&id=d902b3b8&scoped=true"
import script from "./GStatusChip.vue?vue&type=script&lang=js"
export * from "./GStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d902b3b8",
  null
  
)

export default component.exports